<template>
    <div class="initializer">
        <v-stepper v-if="!loadConfiguration" v-model="currentConfiguratorPage" class="stepper mb-12 mx-n6">
            <v-stepper-header>
                <v-stepper-step :complete="currentConfiguratorPage > 1" step="1">Configure Application</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currentConfiguratorPage > 2" step="2">Review Configuration</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currentConfiguratorPage > 3" step="3">Generate Application</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4">Celebration Time</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <ConfigurationDefinition
                            :projectConfiguration="projectConfiguration"
                            @submitConfiguration="submitConfiguration">
                    </ConfigurationDefinition>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <ConfigurationReview
                            :checkingConfiguration="checkingConfiguration"
                            :projectConfiguration="projectConfiguration"
                            @editConfiguration="editConfiguration"
                            @generateApplication="generateApplication">
                    </ConfigurationReview>
                </v-stepper-content>
                <v-stepper-content step="3">
                    <ProcessVisualizer :nodes="data"/>
                </v-stepper-content>
                <v-stepper-content step="4">
                    <div class="celebration-container">
                        <h1>Let's celebrate 🥳🥳🥳</h1>
                        <h3 v-if="generationResult.repositoryUrl">Your new project is located here:</h3>
                        <a v-if="generationResult.repositoryUrl" id="repository-link" target="_blank" :href="generationResult.repositoryUrl">{{generationResult.repositoryUrl}}</a>
                        <h3>You can download a local copy including the initial application.yml here:</h3>
                        <v-btn v-on:click="downloadProject" class="download-btn" color="#42b983" dark large>
                            Download Project
                            <v-icon right>mdi-cloud-download</v-icon>
                        </v-btn>
                    </div>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>
</template>

<script>
// @ is an alias to /src
import ConfigurationDefinition from '@/components/initializer/ConfigurationDefinition.vue'
import ConfigurationReview from "../components/initializer/ConfigurationReview"
import ConfigurationService from "../services/ConfigurationService"
import axios from "axios"
import ProcessVisualizer from "../components/general/ProcessVisualizer"

export default {
        name: 'initializer',
        props: [
            'configurationId'
        ],
        components: {
            ProcessVisualizer: ProcessVisualizer,
            ConfigurationDefinition: ConfigurationDefinition,
            ConfigurationReview: ConfigurationReview
        },
        methods: {
            submitConfiguration: function () {
                this.checkingConfiguration = true
                console.log("submitConfiguration: " + this.projectConfiguration.id)
                ConfigurationService
                    .submitConfiguration({
                        id: this.projectConfiguration.id,
                        applicationName: this.projectConfiguration.name.value,
                        configurationOptions: {
                            port: this.projectConfiguration.port.value,
                            host: this.projectConfiguration.host.value,
                            generateStarter: this.projectConfiguration.generateStarter,
                            generateStandalone: this.projectConfiguration.generateStandalone,
                            template: this.projectConfiguration.template.value,
                            reviewers: this.projectConfiguration.reviewers.value
                        }
                    })
                    .then(configuration => {
                        this.projectConfiguration = configuration
                        this.checkingConfiguration = false
                    })
                this.currentConfiguratorPage = 2
            },
            editConfiguration: function () {
                console.log("editConfiguration: " + this.projectConfiguration.id)
                this.currentConfiguratorPage = 1
            },
            generateApplication: function () {
                console.log("generateApplication: " + this.projectConfiguration.id)
                this.currentConfiguratorPage = 3

              this.socket = new WebSocket(this.websocketUrl)
                this.socket.onopen = () => {
                    console.log("connected to " + this.websocketUrl)
                    this.connected = true
                    this.socket.send(this.projectConfiguration.id)
                }
                this.socket.onerror = error => {
                    console.log("could not connect to " + this.websocketUrl)
                    console.log(error)
                }
                this.socket.onmessage = message => {
                    console.log("event received", message)
                    let data = message.data
                    if (data !== "\"COMPLETED\"") {
                        this.data = JSON.parse(data)
                    } else {
                        this.celebrate()
                    }
                }
                this.socket.onclose = error => {
                    console.log("disconnect from " + this.websocketUrl)
                    this.connected = false
                    console.log(error)
                    setTimeout(() => {
                      this.celebrate()
                    }, 10000)
                }
                const config = {headers: {'Content-Type': 'application/json'}}
                axios
                    .post("[baseContextPath]/applications/initialize/generate", this.projectConfiguration.id, config)
                    .then(response => {
                        return response.data
                    })
            },
            forceFileDownload(response) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', this.projectConfiguration.name.value + ".zip") //or any other extension
                document.body.appendChild(link)
                link.click()
            },
            downloadProject() {
                axios({
                    method: 'get',
                    url: this.generationResult.zipDownloadUrl,
                    responseType: 'arraybuffer'
                }).then(response => {
                    this.forceFileDownload(response)
                }).catch(() => console.log('error occured'))
            },
            celebrate() {
                this.disconnect()
                this.currentConfiguratorPage = 4
                axios
                    .get("[baseContextPath]/applications/initialize/celebrate/" + this.projectConfiguration.id)
                    .then(response => {
                        console.log(response)
                        this.generationResult.repositoryUrl = response.data.remoteUrl
                        this.generationResult.zipDownloadUrl = "[baseContextPath]/applications/initialize/celebrate/" + this.projectConfiguration.id + "/download"
                    })
            },
            disconnect() {
                console.log("trying to disconnect..")
                this.socket.close()
            }
        },
        data() {
            return {
                projectConfiguration: {
                    id: "",
                    state: "NOT_CHECKED",
                    name: {
                        value: "",
                        state: "NOT_CHECKED",
                        messages: {},
                        disabled: false
                    },
                    port: {
                        value: -1,
                        state: "NOT_CHECKED",
                        messages: {},
                        disabled: false
                    },
                    host: {
                        value: "",
                        displayName: "",
                        state: "NOT_CHECKED",
                        messages: {},
                        disabled: false
                    },
                    template: {
                        value: "",
                        displayName: "",
                        state: "NOT_CHECKED",
                        messages: {},
                        disabled: false
                    },
                    reviewers: {
                        value: []
                    }
                },
                generationResult: {
                    repositoryUrl: "",
                    zipDownloadUrl: ""
                },
                loadConfiguration: true,
                checkingConfiguration: true,
                currentConfiguratorPage: 1,
                websocketUrl: process.env.VUE_APP_WEBSOCKET_BASE_URL + "/ws/applications/initialize/progress",
                connected: false,
                data: []
            }
        }, created() {
            if (typeof (this.configurationId) !== 'undefined') {
                this.loadConfiguration = true
                ConfigurationService
                    .getConfiguration(this.configurationId)
                    .then(configuration => {
                        this.projectConfiguration = configuration
                        this.loadConfiguration = false
                        this.checkingConfiguration = false
                        this.currentConfiguratorPage = 2
                    })
            } else {
                this.loadConfiguration = false
            }
        }
    }
</script>

<style>

    .initializer > div.stepper {
        background: transparent;
        border: none;
        box-shadow: none;
    }

    .initializer > div.stepper > div {
        background: transparent;
        border: none;
        box-shadow: none;
    }

    .initializer .celebration-container #repository-link {
        margin: 25px auto;
    }

    .initializer .celebration-container h1 {
        margin-top: 50px;
        text-align: center;
    }

    .initializer .celebration-container h3 {
        margin: 50px 0 25px;
    }

</style>
